// OAuth providers redirect to <frontend>/api/auth/<provider>/callback; the SPA
// forwards that request to the API that owns the flow.

export const GOOGLE_LOGIN_CALLBACK_PATH = "/api/auth/google/callback";

export const INTEGRATION_CALLBACK_PATHS = [
  "/api/auth/linkedin-community/callback",
  "/api/auth/linkedin-ads/callback",
  "/api/auth/google-ads/callback",
  "/api/auth/meta-ads/callback",
  "/api/auth/apollo/callback",
  "/api/auth/hubspot/callback",
  "/api/auth/pipedrive/callback",
  "/api/auth/salesforce/callback",
  "/api/auth/slack/callback",
];

export const toOrigin = (value) => {
  try {
    return new URL(String(value || "").trim()).origin;
  } catch {
    return "";
  }
};

/**
 * Returns the API URL to forward an OAuth callback to, or null when the path is
 * not a callback or already points at that API. The Google login callback must
 * reach the host that started the sign-in (the auth API): its host-only binding
 * cookie was set there.
 */
export const resolveOAuthCallbackForwardUrl = ({
  pathname,
  search = "",
  currentOrigin,
  authApiOrigin,
  integrationsApiOrigin,
}) => {
  let targetOrigin = "";
  if (pathname === GOOGLE_LOGIN_CALLBACK_PATH) {
    targetOrigin = authApiOrigin;
  } else if (INTEGRATION_CALLBACK_PATHS.includes(pathname)) {
    targetOrigin = integrationsApiOrigin;
  }
  if (!targetOrigin || targetOrigin === currentOrigin) return null;
  return `${targetOrigin}${pathname}${search || ""}`;
};
